<div class="file-uploader row" (window:resize)="resize()" #upload_div>
  @for (file of attachedFiles; track file) {
    <div class="col-md-3 col-sm-4 col-four-1440 col-xs-6">
      <div class="attach attach-image">
        @if (!!file.thumbnail) {
          <div class="attach-file">
            <img [src]="file.thumbnail" />
          </div>
        } @else {
          <div class="file-format"><i [ngClass]="file.file_name | fileIconClass"></i></div>
        }
        <a class="file-name">{{ file.file_name }}</a>
        @if (canEdit) {
          <a class="action-file" (click)="removeAttachedFile(file)">
            <i class="fa fa-trash-o"></i>
          </a>
        }
      </div>
    </div>
  }

  @for (item of uploader.queue; track item) {
    <div class="col-md-3 col-sm-4 col-four-1440 col-xs-6">
      <div class="attach attach-image">
        @if (isShowPreview(item)) {
          <div class="attach-file">
            <img appImagePreview [image]="item?._file" />
          </div>
        } @else {
          <div class="file-format"><i [ngClass]="item?.file?.name | fileIconClass"></i></div>
        }
        <a class="file-name">
          {{ item?.file?.name }}
          @if (item.isError) {
            <span>
              <i class="fa fa-exclamation-triangle" aria-hidden="true">&nbsp;Failed to upload</i>
            </span>
          }
        </a>
        @if (canEdit) {
          <a class="action-file" (click)="item.remove()">
            <i class="fa fa-trash-o"></i>
          </a>
        }
      </div>
    </div>
  }
</div>

@if (canEdit) {
  <div>
    @if (authUserService.isTeacher()) {
      <label class="tea-add-file" for="file-upload-{{ index }}">
        @if (option['onlyImage']) {
          <span class="spen-util-link"><i class="fa fa-image"></i>画像を登録する</span>
        } @else {
          <span class="spen-util-link"><i class="fa fa-plus-circle"></i>ファイルを添付する</span>
        }
      </label>
    } @else {
      <label class="stu-add-file" for="file-upload-{{ index }}">
        @if (option['onlyImage']) {
          <div>
            <i class="fa fa-image"></i>
            <span class="spen-util-link">画像を登録する</span>
          </div>
        } @else {
          <i class="fa fa-paperclip"></i>
          <span class="spen-util-link">ファイルを添付する</span>
        }
      </label>
    }
    @if (option['singleSelector']) {
      <input
        id="file-upload-{{ index }}"
        class="input-file"
        type="file"
        (change)="onSelectFile($event)"
        [accept]="acceptTypes"
        ng2FileSelect
        [uploader]="uploader"
      />
    } @else {
      <input
        id="file-upload-{{ index }}"
        class="input-file"
        type="file"
        (change)="onSelectFile($event)"
        [accept]="acceptTypes"
        ng2FileSelect
        [uploader]="uploader"
        multiple
      />
    }
  </div>
}
@if (attachFilesErrMsg) {
  <div class="spen-mod-error-content">
    {{ attachFilesErrMsg }}
  </div>
}

@if (showProgressbar) {
  <app-upload-files-progress [progress]="uploader.progress" (cancelFilesEvent)="cancelUploadingFiles()"> </app-upload-files-progress>
}
